import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule } from '@auth0/angular-jwt';
import { NgProgressModule } from 'ngx-progressbar';
import { NgProgressHttpModule } from 'ngx-progressbar/http';
import { NgProgressRouterModule } from 'ngx-progressbar/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SiteConfig } from '../config/site-config';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MAT_RIPPLE_GLOBAL_OPTIONS, RippleGlobalOptions } from '@angular/material/core';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { PreLoadService } from './preLoad.service';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { LayoutModule } from '@angular/cdk/layout';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from './shared/shared.module';
import { FlexHeaderComponent } from './shared/components/flex-layout/flex-header/flex-header.component';
import { FlexFooterComponent } from './shared/components/flex-footer/flex-footer.component';

/* Changes start here. */
// Import MSAL and MSAL browser libraries.
import { MsalGuard, MsalInterceptor, MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';

// Import the Azure AD B2C configuration
import { msalConfig, protectedResources, loginRequest } from './b2c/auth-config';
import { RedirectComponent } from './redirect/redirect.component';
import { DemoFormPageComponent } from './pages/upscapital/demoformPage/demoformPage.component';
import { ContactUsComponent } from './pages/upscapital/contact-us/contact-us.component';
import { ContinuousCustomsBondsApplicationComponent } from './pages/upscapital/business-services/continuous-customs-bonds-application/continuous-customs-bonds-application.component';
import { OptoutComponent } from './pages/upscapital/optout/optout.component';
/* Changes end here.  */

const globalRippleConfig: RippleGlobalOptions = {
  disabled: true
}; 

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function tokenGetter() {
  return localStorage.getItem(SiteConfig.storageKey.accessToken);
}

export function preLoadServiceFactory (provider: PreLoadService) {
  return provider.load();
}

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,
        MatDialogModule,
        MatProgressBarModule,
        MatRadioModule,
        LayoutModule,
        ReactiveFormsModule,
        MatExpansionModule,
        MatRadioModule,
        MatFormFieldModule,
        FormsModule,
        ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
        MatInputModule,
        MatIconModule,
        MatSelectModule,
        MatAutocompleteModule,
        NgbModule,
        SharedModule,
        JwtModule.forRoot({
            config: {
                tokenGetter: tokenGetter,
                // whitelistedDomains: getWhitelistedDomains(),
                allowedDomains: [
                    'localhost:3000',
                ],
                // blacklistedRoutes: getBlacklistedDomains(),
                disallowedRoutes: [
                    'localhost:3000/auth/'
                ],
                skipWhenExpired: true,
            }
        }),
        NgProgressModule.withConfig({
            color: '#00857d',
            spinner: false,
        }),
        NgProgressHttpModule,
        NgProgressRouterModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient], 
            },
        }),
      /* Changes start here. */
      // Import the HTTP client.
      HttpClientModule,

      // Initiate the MSAL library with the MSAL configuration object
      MsalModule.forRoot(new PublicClientApplication(msalConfig),
        {
          // The routing guard configuration.
          interactionType: InteractionType.Redirect,
          authRequest: {
            scopes: loginRequest.scopes,
            redirectUri: loginRequest.redirectUri
          }
        },
        {
          // MSAL interceptor configuration.
          // The protected resource mapping maps your web API with the corresponding app scopes. If your code needs to call another web API, add the URI mapping here.
          interactionType: InteractionType.Redirect,
          protectedResourceMap: new Map([
            // [protectedResources.todoListApi.endpoint, protectedResources.todoListApi.scopes]
            [protectedResources.webAPI.endpoint, protectedResources.webAPI.scopes]
          ])
        }),
    ],
    declarations: [
        AppComponent,
        FlexHeaderComponent,
        FlexFooterComponent,
        RedirectComponent,
        DemoFormPageComponent,
        ContactUsComponent,
        ContinuousCustomsBondsApplicationComponent,
        OptoutComponent
    ],
    providers: [
        { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
        PreLoadService,
        DatePipe,
        TitleCasePipe,
        /* Changes start here. */
        {
        provide: HTTP_INTERCEPTORS,
        useClass: MsalInterceptor,
        multi: true
        },
        MsalGuard
        /* Changes end here. */
        /* ,
        { provide: APP_INITIALIZER, useFactory: preLoadServiceFactory, deps: [PreLoadService], multi: true } */
    ],
    bootstrap: [AppComponent,
        /* Changes start here. */
        MsalRedirectComponent
        /* Changes end here. */
    ]
})
export class AppModule {}
